export { Layout6 } from "./Layout6";

